module.exports = __webpack_public_path__ + "img/reward_4200.493d8dc7.png";